import React, { useState, useEffect } from "react";
import Button from "@components/Button";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Typography from "@components/Typography";
import { __t } from "@core/translation/translation";
import copyToClipboard from "@core/utils/copyToClipboard/copyToClipboard";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    // width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
    "& .MuiAlert-action": {
      display: "none",
    },
  },
  copyIcon: {
    color: theme.palette.primary.main,
    fontSize: theme.fontSize["18"],
    marginRight: theme.spacing(2),
  },
  copyText: {
    fontSize: theme.fontSize["14"],
    color: theme.palette.primary.main,
  },
  button: {
    backgroundColor: "rgba(0,255,0, 0.09)",
    marginRight: theme.spacing(2),
  },
}));

export default function CustomizedSnackbars({
  text,
  message,
  HideText = false,
}) {
  const classes = useStyles();
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [isAddressCopied, setIsAddressCopied] = useState(false);

  const handleClick = () => {
    copyToClipboard(text) && setIsAddressCopied(true);
    setOpenSnackbar(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  useEffect(() => {
    if (isAddressCopied) {
      setTimeout(() => setIsAddressCopied(false), 2000);
    }
  }, [isAddressCopied]);

  return (
    <div className={classes.root}>
      <Button
        disabled={isAddressCopied}
        onClick={handleClick}
        size="xs2"
        className={classes.button}
      >
        <span className={clsx("icon-copy", classes.copyIcon)}></span>
        {!HideText && (
          <Typography isBold className={classes.copyText}>
            {__t("copy")}
          </Typography>
        )}
      </Button>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={2000}
        onClose={handleClose}
      >
        <Alert severity="success">{message}</Alert>
      </Snackbar>

      {/* <Alert severity="success">This is a success message!</Alert> */}
    </div>
  );
}
